<template>
    <div />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useLoadCart } from '@/composables/useLoadCart';
import { APPLICATION_PROCESS, PAYMENT } from '@/router/route-name';

const router = useRouter();
const route = useRoute();

onMounted(async () => {
    const isLoadedCart = await useLoadCart();
    if (isLoadedCart) {
        router.push({ name: PAYMENT, query: route.query });
    } else {
        router.push({ name: APPLICATION_PROCESS });
    }
});
</script> 